export const selectAuthOpen = (state: RootState) => state.modals.isAuthOpen;
export const selectOutOpen = (state: RootState) => state.modals.isOutOpen;
export const selectNotifyOpen = (state: RootState) => state.modals.isNotifyOpen;
export const selectNotifyProps = (state: RootState) => state.modals.notifyProps;
export const selectDialogOpen = (state: RootState) => state.modals.isDialogOpen;
export const selectDialogProps = (state: RootState) => state.modals.dialogProps;
export const selectDichotomousOpen = (state: RootState) => state.modals.isDichotomousOpen;
export const selectDichotomousProps = (state: RootState) => state.modals.dichotomousProps;
export const selectSupportOpen = (state: RootState) => state.modals.isSupportOpen;
export const selectModerationOpen = (state: RootState) => state.modals.isModerationOpen;
export const selectModerationProps = (state: RootState) => state.modals.moderationProps;
export const selectIsPopupVisible = (state: RootState) => state.modals.isPopupVisible;
export const selectPopupProps = (state: RootState) => state.modals.popupProps;
export const selectFrameModal = (state: RootState) => state.modals.modalFrame;
export const selectPaymentOpen = (state: RootState) => state.modals.isPaymentOpen;
export const selectRecommendOpen = (state: RootState) => state.modals.isRecommendOpen;
export const selectRecommendProps = (state: RootState) => state.modals.recommendProps;
export const selectActionOpen = (state: RootState) => state.modals.isActionOpen;
export const selectAddOpen = (state: RootState) => state.modals.isAddOpen;
